// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1ik9e","calendarButtons":"ClockData_calendarButtons__dnWM1"};